import { createContext } from 'react';

export const PuzzleContext = createContext();
